// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"738c4437","856":"9267ac7c","952":"cdc4479b"}[chunkId] + ".chunk.js";
};